var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ItemGroup } from './item-group';
import { Data } from './data';
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Item";
        _this.published = true;
        _this.suspended = false;
        _this.inventory = -1;
        _this.quantity = 0;
        _this.points = 0;
        _this.groupIds = [];
        _this.mgroupIds = [];
        _this.groups = [];
        _this.mgroups = [];
        _this.modifier = false;
        _this.combo = false;
        _this.modifiable = false;
        _this.printers = [];
        _this.baseQty = 0;
        _this.soldQty = 0;
        _this.dinein = false;
        _this.handling = 0;
        _this.discount = 0;
        _this.discountCode = "";
        _this.isPrint = true;
        _this.prefix = "";
        _this.discounted = false;
        _this.discounts = [];
        _this.discountable = true;
        _this.featuredRating = 0;
        _this.addTime = Number(new Date());
        _this.featured = false;
        return _this;
    }
    Item.prototype.toProperty = function (name, value) {
        switch (name) {
            case "groups":
                value = Data.toDataArray(ItemGroup, value);
                break;
            case "mgroups":
                value = Data.toDataArray(ItemGroup, value);
                break;
            default:
                value = _super.prototype.toProperty.call(this, name, value);
                break;
        }
        return value;
    };
    Item.isSet = function (category, item) {
        if (item.groups && item.groups.length > 0) {
            return true;
        }
        if (category && category.groups && category.groups.length > 1) {
            return true;
        }
        return false;
    };
    Item.isModifiable = function (item) {
        var mgroups = item.mgroups;
        if (!mgroups || mgroups.length == 0) {
            return false;
        }
        return mgroups.some(function (g) { return g.items && g.items.length > 0; });
    };
    Item.isPublished = function (item, now) {
        if (!item.start && !item.end)
            return true;
        var greaterThanStart = true;
        var lessThanEnd = true;
        if (item.start) {
            greaterThanStart = now >= item.start;
        }
        if (item.end) {
            lessThanEnd = now <= item.end;
        }
        return greaterThanStart && lessThanEnd;
    };
    Item.filterPublished = function (items, now) {
        var result = [];
        if (!items || items.length == 0)
            return result;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.published && Item.isPublished(item, now)) {
                result.push(item);
            }
        }
        return result;
    };
    Item.filterPublishedItems = function (items, cmap, catId, index, filter) {
        var result = [];
        var catIdWithIndex = catId + "." + index.toString();
        if (!items || items.length == 0)
            return result;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            if (item.groups.length == 0) {
                item.combo = false;
            }
            if (cmap && (cmap[catIdWithIndex] || cmap[catId])) {
                var published = cmap[catIdWithIndex] ? cmap[catIdWithIndex] : cmap[catId];
                if (published && published[item.id]) {
                    result.push(item);
                }
            }
            else {
                if (filter) {
                    if (filter(item)) {
                        result.push(item);
                    }
                }
                else if (item.published) {
                    result.push(item);
                }
            }
        }
        return result;
    };
    Item.toItemsData = function (items) {
        var results = [];
        for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
            var item = items_3[_i];
            var tmp = Item.toItemData(item);
            results.push(tmp);
        }
        return results;
    };
    Item.toItemData = function (item) {
        var json = {};
        json["id"] = item.id;
        json["quantity"] = item.quantity;
        json["name"] = item.name;
        json["price"] = item.price;
        json["price0"] = item.price0;
        json["price1"] = item.price1;
        json["price2"] = item.price2;
        json["modifiable"] = item.modifiable;
        json["modifier"] = item.modifier;
        if (item.points > 0) {
            json["usedPoints"] = item.points;
        }
        json["discounted"] = item.discounted;
        json["mgroups"] = item.mgroups ? ItemGroup.toItemGroupsData(item.mgroups) : null;
        json["comboId"] = item.comboId;
        json["comboName"] = item.comboName;
        json["taxGroup"] = item.taxGroup;
        json["discountedId"] = item.discountedId;
        json["barcode"] = item.barcode;
        return json;
    };
    Item.getPrice = function (item, level) {
        var result = item.price;
        switch (level) {
            case 1:
                result = item['price1'];
                break;
            case 2:
                result = item['price2'];
                break;
            case 3:
                result = item['price3'];
                break;
            case 4:
                result = item['price4'];
                break;
            case 5:
                result = item['price5'];
                break;
            case 6:
                result = item['price6'];
                break;
            case 7:
                result = item['price7'];
                break;
            case 8:
                result = item['price8'];
                break;
            case 9:
                result = item['price9'];
                break;
            default:
                result = item['price1'];
                break;
        }
        if (!result && result != 0) {
            result = item.price;
        }
        return result;
    };
    return Item;
}(Data));
export { Item };
//# sourceMappingURL=item.js.map